// extracted by mini-css-extract-plugin
module.exports = {"image":"PhotoNavigation_image__bco7J"};